/**
 * Normalise a value that is expected to be an array.
 *
 * Remote payloads are the shape they are, not the shape we assume: a list endpoint that
 * answers with an object (or a string) instead of a list used to reach `.map()` and throw
 * "is not a function" during render. `value || []` is not enough — a non-empty object or a
 * non-empty string is truthy, so the guard has to test the type.
 */
export default function asArray(value) {
  return Array.isArray(value) ? value : [];
}
